import { useEffect, useState } from "react";
import { RefreshCw, MessageSquare, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { SmsProviderCard } from "@/components/sms/SmsProviderCard";
import { SmsWindowSettings } from "@/components/sms/SmsWindowSettings";
import { SmsComposer } from "@/components/sms/SmsComposer";
import { SmsCampaignRow } from "@/components/sms/SmsCampaignRow";
import { errMsg } from "@/components/sms/smsUtils";

const FILTERS = [["all", "Tutte"], ["draft", "Bozze"], ["scheduled", "Programmate"], ["sending", "In invio"], ["sent", "Inviate"]];

export default function Sms() {
  const [ov, setOv] = useState(null);
  const [credit, setCredit] = useState(null);
  const [clusters, setClusters] = useState([]);
  const [lists, setLists] = useState([]);
  const [error, setError] = useState(null);
  const [filter, setFilter] = useState("all");

  const load = async (withCredit = false) => {
    setError(null);
    try {
      const [o, c, l] = await Promise.all([api.get("/sms/panel/overview"), api.get("/clusters"), api.get("/lists")]);
      setOv(o.data); setClusters(c.data || []); setLists(l.data || []);
      if (withCredit && o.data.provider === "2ck") api.get("/sms/2ck/status?credit=1").then((r) => setCredit(r.data.credit)).catch(() => {});
    } catch (e) { setError(errMsg(e)); }
  };
  useEffect(() => { load(); }, []);

  if (error) return <div className="p-6 text-sm text-[#FCA5A5]" data-testid="sms-page-error">{error}</div>;
  if (!ov) return <div className="p-10 flex justify-center text-slate-400" data-testid="sms-page-loading"><Loader2 className="h-6 w-6 animate-spin" /></div>;

  const camps = (ov.campaigns || []).filter((c) => filter === "all" ? true : filter === "sent" ? ["sent", "completed"].includes(c.status) : filter === "scheduled" ? ["scheduled", "queued"].includes(c.status) : c.status === filter);

  return (
    <div className="space-y-6 animate-in fade-in duration-300" data-testid="sms-page">
      <div className="flex items-end justify-between gap-3 flex-wrap">
        <div>
          <p className="text-xs uppercase tracking-[0.25em] text-[#10B981]">Canale SMS</p>
          <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-slate-100 flex items-center gap-3"><MessageSquare className="h-8 w-8 text-[#10B981]" />SMS</h1>
          <p className="text-sm text-slate-400 mt-1 max-w-2xl">Invii SMS del canale <b className="text-slate-200">{ov.tenant}</b>: bozze, pianificazioni, blocchi e notifiche di consegna. Ogni invio reale richiede anteprima e conferma esplicita.</p>
        </div>
        <Button variant="ghost" onClick={() => load(true)} data-testid="sms-refresh-btn"><RefreshCw className="h-4 w-4 mr-2" />Aggiorna {ov.provider === "2ck" ? "e credito" : ""}</Button>
      </div>

      <SmsProviderCard ov={ov} credit={credit} />
      {ov.provider === "2ck" && ov.limits && <SmsWindowSettings lim={ov.limits} onSaved={() => load()} />}
      <SmsComposer ov={ov} clusters={clusters} lists={lists} onSaved={() => load()} />

      <section className="space-y-3" data-testid="sms-campaign-list">
        <div className="flex items-center justify-between flex-wrap gap-2">
          <h2 className="text-base md:text-lg font-semibold text-slate-100">Campagne SMS <span className="text-slate-500 text-sm font-normal">({camps.length})</span></h2>
          <div className="flex gap-1 flex-wrap">
            {FILTERS.map(([v, l]) => <button key={v} type="button" onClick={() => setFilter(v)} data-testid={`sms-filter-${v}`} className={`px-3 py-1 rounded-full text-xs border transition-colors ${filter === v ? "bg-[#1F2937] text-slate-100 border-slate-500" : "border-[#1F2937] text-slate-400"}`}>{l}</button>)}
          </div>
        </div>
        {camps.length === 0 ? <p className="text-sm text-slate-500 border border-dashed border-[#1F2937] rounded-xl p-6 text-center" data-testid="sms-empty">Nessuna campagna SMS {filter !== "all" ? "in questo stato" : "ancora: crea la prima bozza qui sopra"}.</p>
          : <ul className="space-y-2">{camps.map((c) => <SmsCampaignRow key={c.id} c={c} ov={ov} onChanged={() => load()} />)}</ul>}
      </section>
    </div>
  );
}
